import equal from 'fast-deep-equal';
/**
 * Wrapping the existing library such that can be replaced in future.
 * @param itemA
 * @param itemB
 */
export function isEqual<T>(itemA: T, itemB: T) {
  return equal(itemA, itemB);
}
